import { FirebaseStore } from '@interfaces/firebase.interfaces';
import createStore from 'zustand';

const useFirebaseStore = createStore<FirebaseStore>((set) => ({
	accounts: {},
	setAccounts: (accounts) => set({ accounts }),
	combos: {},
	setCombos: (combos) => set({ combos }),
	hosts: null,
	setHosts: (hosts) => set({ hosts }),
	serviceLevels: {},
	setServiceLevels: (serviceLevels) => set({ serviceLevels }),
	terminals: {},
	setTerminals: (terminals) => set({ terminals }),
}));

export default useFirebaseStore;
